import type { Agent } from "@/types/aiToolkit";
import type { TelegramAgentPermissions } from "@/types/telegram";
import { DEFAULT_TELEGRAM_AGENT_PERMISSIONS } from "@/types/telegram";
import { telegramService } from "@/services/telegramService";

export function agentCanUseTelegramRead(agent: Agent | null | undefined): boolean {
  if (!agent) return false;
  return agent.capabilityModules?.includes("cap-telegram-read") ?? false;
}

export function agentCanUseTelegramWrite(agent: Agent | null | undefined): boolean {
  if (!agent) return false;
  const hasCap = agent.capabilityModules?.includes("cap-telegram-write");
  const hasTool = agent.allowedToolIds?.includes("telegram");
  return Boolean(hasCap && hasTool);
}

export async function fetchTelegramPermissions(): Promise<TelegramAgentPermissions> {
  const status = await telegramService.getStatus();
  return status.agentPermissions ?? DEFAULT_TELEGRAM_AGENT_PERMISSIONS;
}

async function ensurePermission(
  key: keyof TelegramAgentPermissions,
  label: string
): Promise<boolean> {
  const perms = await fetchTelegramPermissions();
  if (perms[key]) return true;
  throw new Error(`Enable "${label}" in Telegram AI agent permissions first.`);
}

export async function ensureTelegramReadPermission(): Promise<boolean> {
  return ensurePermission("readMessages", "Read messages");
}

export async function ensureTelegramSendPermission(): Promise<boolean> {
  return ensurePermission("sendMessages", "Send messages");
}

export async function ensureTelegramRagPermission(): Promise<boolean> {
  return ensurePermission("indexRag", "Index to RAG");
}

export async function ensureTelegramClickUpPermission(): Promise<boolean> {
  return ensurePermission("postToClickUp", "Post to ClickUp");
}

export async function ensureTelegramDocumentPermission(): Promise<boolean> {
  return ensurePermission("createDocuments", "Create documents");
}
